import React, { useState } from "react";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const REASONS = ["Spam or scam", "Harassment or hate", "Misleading claims (medical, legal, financial)", "Explicit or unsafe content", "Something else"];

export function ReportButton({ type, id, label, className = "" }: { type: "post" | "reader" | "product" | "message" | "thread"; id: string; label?: string; className?: string }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(REASONS[0]);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  if (!user) return null;
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/reports", { target_type: type, target_id: id, reason: note.trim() ? `${reason}: ${note.trim()}` : reason });
      toast.success("Thanks — our moderators will review this."); setOpen(false); setNote("");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={`inline-flex items-center gap-1 text-xs text-[#5E5C56] hover:text-[#581C25] ${className}`} data-testid={`report-${type}-${id}`}><Flag size={13} />{label}</button>
      {open && (
        <div className="fixed inset-0 z-[60] bg-[#121110]/60 flex items-end sm:items-center justify-center p-4 pb-20 sm:pb-4" onClick={() => setOpen(false)} data-testid="report-modal">
          <div className="bg-[#F6F4EE] text-[#1A1917] rounded-md w-full max-w-md p-6 space-y-3" onClick={(e) => e.stopPropagation()}>
            <p className="eyebrow">Report {type}</p>
            <h3 className="serif text-2xl leading-tight">What's wrong here?</h3>
            <div className="space-y-1.5">{REASONS.map((r) => <label key={r} className="flex items-center gap-2 text-sm"><input type="radio" className="accent-[#581C25]" checked={reason === r} onChange={() => setReason(r)} data-testid={`report-reason-${REASONS.indexOf(r)}`} />{r}</label>)}</div>
            <textarea className="input-ed" rows={3} placeholder="Add details (optional)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="report-note" />
            <div className="flex justify-end gap-2"><button onClick={() => setOpen(false)} className="btn-ghost !py-2 text-xs">Cancel</button><button onClick={submit} disabled={busy} className="btn-wine !py-2 text-xs" data-testid="report-submit">Send report</button></div>
          </div>
        </div>
      )}
    </>
  );
}
